function LoadingPage() {
    return (
        <h3 className={'loading-page'}>Loading...</h3>
    )
}

export default LoadingPage